// data.js
export const Categories = [
    {
        title: "ENGINE / FUEL PARTS",
        image: "/assets/engine.jpg",
        items: ["ACTUATOR", "AIR BREATHER", "AIR CLEANER", "AIR CLEANER HOSE"],
        link: "#"
    },
    {
        title: "SUSPENSION / POWER STEERING PARTS",
        image: "/assets/power.jpg",
        items: ["ACTUATOR", "AIR TANK", "ASSISTOR ASM POWER SHIFT", "AXLE"],
        link: "#"
    },
    {
        title: "BATTERY",
        image: "/assets/battery.avif",
        items: ["ALL BATTERIES", "BATTERY CARRIER", "BATTERY COVER", "DRY BATTERY"],
        link: "#"
    },
    {
        title: "LUBRICANT AND ADDITIVES",
        image: "/assets/Engine Oil.jpg",
        items: ["ADDITIVES", "AIR CLEANER", "AIR FLOW SENSOR", "ATF/CVTF"],
        link: "#"
    },
    {
        title: "BEARING",
        image: "/assets/351-600x600.jpg",
        items: ["ALL BEARINGS", "BOOSTER", "CENTER BEARING", "CLUTCH BEARING"],
        link: "#"
    },
    {
        title: "BRAKE PARTS",
        image: "/assets/break-parts.jpg",
        items: ["BEARING", "BLOWER", "BOOSTER", "BOOT"],
        link: "#"
    }
];
